import { render, staticRenderFns } from "./m_chat_list.vue?vue&type=template&id=3fa28fda&scoped=true&"
import script from "./m_chat_list.vue?vue&type=script&lang=js&"
export * from "./m_chat_list.vue?vue&type=script&lang=js&"
import style0 from "./m_chat_list.vue?vue&type=style&index=0&id=3fa28fda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa28fda",
  null
  
)

export default component.exports